import { baseAPIRequest } from 'utilities/http';

async function postUnsubscribeAll (emailAddress) {

	try {

		const response = await baseAPIRequest({
			url: '/api/singleprofile/user-profile/unsubscribe',
			data: {
				EmailAddress: emailAddress
			},
			params: { method: 'POST' }
		});

		if (!response.IsSuccess) {

			const [ error ] = response.ErrorMessages;
			// ignore NoProfileFound error, treat it as success
			if (error !== 'NoProfileFound') {

				throw new Error(error || 'Unexpected error');

			}

		}

		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default postUnsubscribeAll;
